import React from 'react';

interface GroupPreviewProps {
  group: {
    id: string;
    documentNames: string[];
    settingsSummary: string;
    totalPages: number;
    price: number;
    tierApplied: string;
  };
  index: number;
}

const GroupPreview: React.FC<GroupPreviewProps> = ({ group, index }) => {
  return (
    <div className="bg-gray-50 rounded-lg p-3 sm:p-4 border border-gray-200">
      {/* Header with Group name and Price */}
      <div className="flex justify-between items-start gap-2 mb-3">
        <h4 className="font-semibold text-sm text-gray-800">
          Group {index + 1}
        </h4>
        <p className="text-lg font-bold text-blue-600 whitespace-nowrap">₹{group.price.toFixed(2)}</p>
      </div>
      
      {/* Settings Summary */}
      <p className="text-xs text-gray-600 mb-3 break-words">{group.settingsSummary}</p>
      
      {/* Pages and Tier Info */}
      <div className="flex flex-wrap gap-x-3 gap-y-1 mb-3 text-xs">
        <span className="text-gray-500">{group.totalPages} pages</span>
        {group.tierApplied !== 'Estimated' && (
          <span className="text-green-600 font-medium">Tier: {group.tierApplied}</span>
        )}
      </div>
      
      {/* Documents List */}
      <div className="text-xs text-gray-500">
        <p className="font-medium mb-1">Documents ({group.documentNames.length}):</p>
        <ul className="list-none pl-0 space-y-1">
          {group.documentNames.map((name, i) => (
            <li key={i} className="break-words truncate max-w-full" title={name}>
              • {name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default GroupPreview;
